<template>
  <div class="rfq-view-page">
    <div class="d-flex justify-content-between">
      <p class="page-breadcrumbs-manual"><span @click="$router.push('/')">Home </span><span
          @click="$router.push('/claims')">// View Rental Claims</span> <span class="active">// View Rental Claim</span>
      </p>

      <div class="d-flex align-items-center" v-if="isOpenGallery"
           style="position: relative; transform: translateY(-11px);">
        <b-button variant="primary" @click="onClickDownload">
          Download
        </b-button>

        <div v-if="claim.images[slide] && claim.images[slide].id && claim.images[slide].isCanRemove"
             class="remove-img-btn-2" @click="removeFile(claim.images[slide].id, 'img')">
          <feather-icon
              icon="Trash2Icon"
              size="21"
              style="color: red; cursor: pointer"
          />
        </div>

        <span @click="isOpenGallery = false" class="close-btn">×</span>
      </div>
    </div>

    <div v-if="!isOpenPdf && !isOpenGallery" class="d-flex justify-content-between"
         style="padding-left: 22px; padding-right: 17px">
      <div class="">
        <p><b>Ref: {{ claim.refNbr }}</b></p>
        <p>{{ claimId ? formatDate(claim.vehicle.arriveDate) : formatDate(new Date()) }}</p>
      </div>
      <div class="">
        <b-button v-if="claim.isManual && !claim.isCanUpdateBms" variant="primary" @click="sendToBMS" style="margin-bottom: 10px" :disabled="claim.isSendingToBms || claim.isSentToBms" class="bms-btn">
          <template v-if="claim.isSendingToBms">Sending to BMS</template>
          <template v-else-if="claim.isSentToBms">Already Sent to BMS</template>
          <template v-else>Send to BMS</template>
        </b-button>

        <b-button v-if="claim.isManual && claim.isCanUpdateBms" variant="primary" @click="sendToBMS" style="margin-bottom: 10px" :disabled="claim.isUpdatingBms || claim.isUpdatedBms" class="bms-btn">
          <template v-if="claim.isUpdatingBms">Sending the Update to BMS</template>
          <template v-else-if="claim.isUpdatedBms">Already Sent the Update to BMS</template>
          <template v-else>Send the Update to BMS</template>
        </b-button>
      </div>
    </div>

    <div v-if="!isOpenPdf && !isOpenGallery" class="d-flex" style="justify-content: space-between">
      <div class="col-lg-9">
        <b-card>
          <b-form-checkbox v-model="claim.partsRequest" :disabled="true" style="margin-bottom: 10px; margin-left: 15px">
            Rental Car requested
          </b-form-checkbox>

          <div class="d-flex">
            <div class="col-lg-4">
              <div role="group">
                <label for="rego">Rego:</label>
                <input
                    id="rego"
                    placeholder="Rego"
                    class="form-control"
                    :readonly="!claim.isManual"
                    @change="autoUpdateVehicle"
                    @focus="focusedElement = 'rego'"
                    @blur="onBlur('rego')"
                    v-model="claim.vehicle.rego"
                />
              </div>

              <div role="group">
                <label for="make">Make:</label>
                <input
                    id="make"
                    placeholder="Make"
                    class="form-control"
                    :readonly="!claim.isManual"
                    @change="autoUpdateVehicle"
                    @focus="focusedElement = 'make'"
                    @blur="onBlur('make')"
                    v-model="claim.vehicle.make"
                />
              </div>

              <div role="group">
                <label for="model">Model:</label>
                <input
                    id="model"
                    placeholder="Model"
                    v-model="claim.vehicle.model"
                    class="form-control"
                    :readonly="!claim.isManual"
                    @change="autoUpdateVehicle"
                    @focus="focusedElement = 'model'"
                    @blur="onBlur('model')"
                />
              </div>

              <div role="group">
                <label for="refNumber">Reference Nbr:</label>
                <input
                    id="refNumber"
                    placeholder="Reference Nbr"
                    v-model="claim.vehicle.refNbr"
                    class="form-control"
                    :readonly="!claim.isManual"
                    @focus="focusedElement = 'refNbr'"
                    @blur="onBlur('refNbr')"
                    @change="autoUpdateVehicle"
                />
              </div>
            </div>
            <div class="col-lg-4">
              <div role="group">
                <label for="arriveDate">Arrive Date:</label>
                <b-input-group>
                  <input
                      v-if="claim.isManual"
                      id="arriveDate"
                      class="form-control form-control-border-focus"
                      v-model="claim.vehicle.arriveDate"
                      @focus="focusedElement = 'arriveDate'"
                      @blur="onBlur('arriveDate')"
                      @change="autoUpdateVehicle"
                      type="text"
                      placeholder="DD/MM/YYYY"
                      autocomplete="off"
                      @keypress="onlyDateFormat"
                      maxlength="10"
                      :readonly="!claim.isManual"
                  />
                  <input
                      v-else
                      class="form-control"
                      :value="formatDate2(claim.vehicle.arriveDate)"
                      type="text"
                      placeholder="DD/MM/YYYY"
                      autocomplete="off"
                      maxlength="10"
                      readonly
                  />
                  <b-input-group-append>
                    <b-form-datepicker
                        v-if="claim.isManual"
                        button-only
                        style="max-height: 38px"
                        right
                        aria-controls="arriveDate"
                        v-model="arrivedDateValue"
                        @input="claim.vehicle.arriveDate = formatDate2(arrivedDateValue); autoUpdateVehicle()"
                        placeholder="Arrive Date"
                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                        locale="en-US"
                        class="icon-calendar-form-datepicker"
                        :disabled="!claim.isManual"
                    ></b-form-datepicker>

                  </b-input-group-append>
                </b-input-group>
              </div>

              <div role="group">
                <label for="startDate">Start Date:</label>
                <b-input-group>
                  <input
                      v-if="claim.isManual"
                      id="startDate"
                      class="form-control"
                      v-model="claim.vehicle.startDate"
                      @change="autoUpdateVehicle"
                      @focus="focusedElement = 'startDate'"
                      @blur="onBlur('startDate')"
                      type="text"
                      placeholder="DD/MM/YYYY"
                      autocomplete="off"
                      @keypress="onlyDateFormat"
                      maxlength="10"
                      :readonly="!claim.isManual"
                  />
                  <input
                      v-else
                      class="form-control"
                      :value="formatDate2(claim.vehicle.startDate)"
                      type="text"
                      placeholder="DD/MM/YYYY"
                      autocomplete="off"
                      maxlength="10"
                      readonly
                  />
                  <b-input-group-append>
                    <b-form-datepicker
                        v-if="claim.isManual"
                        button-only
                        style="max-height: 38px"
                        right
                        aria-controls="startDate"
                        v-model="startDateValue"
                        @input="claim.vehicle.startDate = formatDate2(startDateValue); autoUpdateVehicle()"
                        placeholder="Start Date"
                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                        locale="en-US"
                        class="icon-calendar-form-datepicker"
                        :disabled="!claim.isManual"
                    ></b-form-datepicker>

                  </b-input-group-append>
                </b-input-group>
              </div>

              <div role="group">
                <label for="complDate">Compl Date:</label>
                <b-input-group>
                  <input
                      v-if="claim.isManual"
                      id="complDate"
                      @focus="focusedElement = 'completeDate'"
                      @blur="onBlur('completeDate')"
                      class="form-control"
                      v-model="claim.vehicle.completeDate"
                      @change="autoUpdateVehicle"
                      type="text"
                      placeholder="DD/MM/YYYY"
                      autocomplete="off"
                      @keypress="onlyDateFormat"
                      maxlength="10"
                      :readonly="!claim.isManual"
                  />
                  <input
                      v-else
                      class="form-control"
                      :value="formatDate2(claim.vehicle.completeDate)"
                      type="text"
                      placeholder="DD/MM/YYYY"
                      autocomplete="off"
                      maxlength="10"
                      readonly
                  />
                  <b-input-group-append>
                    <b-form-datepicker
                        v-if="claim.isManual"
                        button-only
                        style="max-height: 38px"
                        right
                        aria-controls="complDate"
                        v-model="completedDateValue"
                        @input="claim.vehicle.completeDate = formatDate2(completedDateValue); autoUpdateVehicle()"
                        placeholder="Compl Date"
                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                        locale="en-US"
                        class="icon-calendar-form-datepicker"
                        :disabled="!claim.isManual"
                    ></b-form-datepicker>

                  </b-input-group-append>
                </b-input-group>
              </div>

              <div role="group">
                <label for="pickupDate">Pickup Date:</label>
                <b-input-group>
                  <input
                      v-if="claim.isManual"
                      id="pickupDate"
                      class="form-control"
                      @focus="focusedElement = 'pickupDate'"
                      @blur="onBlur('pickupDate')"
                      v-model="claim.vehicle.pickupDate"
                      @change="autoUpdateVehicle"
                      type="text"
                      placeholder="DD/MM/YYYY"
                      autocomplete="off"
                      @keypress="onlyDateFormat"
                      maxlength="10"
                      :readonly="!claim.isManual"
                  />
                  <input
                      v-else
                      class="form-control"
                      :value="formatDate2(claim.vehicle.pickupDate)"
                      type="text"
                      placeholder="DD/MM/YYYY"
                      autocomplete="off"
                      maxlength="10"
                      readonly
                  />
                  <b-input-group-append>
                    <b-form-datepicker
                        v-if="claim.isManual"
                        button-only
                        style="max-height: 38px"
                        right
                        aria-controls="pickupDate"
                        v-model="pickUpDateValue"
                        @input="claim.vehicle.pickupDate = formatDate2(pickUpDateValue); autoUpdateVehicle()"
                        placeholder="Pickup Date"
                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                        locale="en-US"
                        class="icon-calendar-form-datepicker"
                        :disabled="!claim.isManual"
                    ></b-form-datepicker>

                  </b-input-group-append>
                </b-input-group>
              </div>
            </div>
            <div class="col-lg-4">
              <div role="group">
                <label for="accidentDesc">Accident Description:</label>
                <b-form-textarea
                    id="accidentDesc"
                    placeholder="Accident Description"
                    rows="3"
                    :readonly="!claim.isManual"
                    @focus="focusedElement = 'accidentDesc'"
                    @blur="onBlur('accidentDesc')"
                    @change="autoUpdateVehicle"
                    v-model="claim.vehicle.accidentDesc"
                    no-resize
                ></b-form-textarea>
              </div>
              <b-button v-if="claim.isManual && newNote == null" variant="primary" @click="newNote = '';" style="margin-top: 10px">
                Add Note
              </b-button>
              <b-button v-if="claim.isManual && newNote !== null" variant="primary" @click="saveNote" :disabled="!newNote.trim().length" class="save-note-btn">
                Save Note
              </b-button>

              <div role="group" v-if="newNote !== null" style="margin-bottom: 10px; margin-top: 15px">
                <div class="" style="border: 1px solid #d8d6de; border-radius: 0.357rem; padding-bottom: 43px" :class="{'active-note': isNoteFocused}">
                  <textarea
                      id="notes"
                      placeholder="Notes"
                      rows="6"
                      style="resize: none; border: none; overflow-y: scroll; box-shadow: none"
                      class="form-control"
                      v-model="newNote"
                      @focus="isNoteFocused = true"
                      @blur="isNoteFocused = false"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
        </b-card>

        <div class="">
          <div class="d-flex">
            <div class="d-flex dashboard-tab-title" @click="activeTab = 'notes'">
              <div class="dashboard-tab-text" :class="{'active': activeTab == 'notes'}">Notes</div>
              <div class="dashboard-tab-line" v-if="activeTab == 'notes'"></div>
            </div>
            <div class="d-flex dashboard-tab-title" @click="activeTab = 'activity'">
              <div class="dashboard-tab-text" :class="{'active': activeTab == 'activity'}">Shared Activity</div>
              <div class="dashboard-tab-line" v-if="activeTab == 'activity'"></div>
            </div>
            <div class="d-flex dashboard-tab-title" @click="activeTab = 'files'">
              <div class="dashboard-tab-text" :class="{'active': activeTab == 'files'}">Files</div>
              <div class="dashboard-tab-line" v-if="activeTab == 'files'"></div>
            </div>
            <div class="d-flex dashboard-tab-title" @click="activeTab = 'images'">
              <div class="dashboard-tab-text" :class="{'active': activeTab == 'images'}">Images</div>
              <div class="dashboard-tab-line" v-if="activeTab == 'images'"></div>
            </div>
            <div class="d-flex dashboard-tab-title" @click="activeTab = 'request'">
              <div class="dashboard-tab-text" :class="{'active': activeTab == 'request'}">Parts Request</div>
              <div class="dashboard-tab-line" v-if="activeTab == 'request'"></div>
            </div>
          </div>
          <div class="main-tab-line"></div>
        </div>
        <b-card v-show="activeTab === 'notes'" title="Notes">
          <div style="padding-left: 0px; width: 100%">
            <b-card v-for="(n, ind) in computedClaimNotes" :key="ind" style="border: 3px solid #f8f8f8">
              <div class="d-flex">
                <div class="col-lg-8">
                  <b-card-text v-if="n.noteType"><b>{{n.noteType}}</b></b-card-text>
                  <b-card-text>{{n.body}}</b-card-text>
                </div>
                <div class="col-lg-4" style="text-align: end">
                  {{formatDate4(n.created)}}
                  <span v-if="n.createdByUser">
                    <br/>
                    {{n.createdByUser}}
                  </span>
                </div>
              </div>
            </b-card>
          </div>
        </b-card>
        <b-card v-show="activeTab === 'activity'" title="Shared Activity">

          <div class="d-flex">
            <div style="padding: 0px; display: flex; justify-content: center; width: 40px;">
              <div style="width: 3px; height: 100%; background-color: #7367f0;"></div>
            </div>

            <div style="padding-left: 0px; width: 100%">
              <b-card v-if="getActivityName(a)" v-for="(a, ind) in claim.sharedActivity" :key="ind" style="border: 3px solid #f8f8f8">
                <div class="d-flex">
                  <div class="col-lg-8">
                    <b-card-text><b>{{getActivityName(a)}}</b></b-card-text>
                  </div>
                  <div class="col-lg-4" style="text-align: end">
                    {{formatDate3(a.eventDate)}}
                  </div>
                </div>
              </b-card>
            </div>
          </div>
        </b-card>
        <b-card v-show="activeTab === 'files'" title="Files">
          <vue-dropzone
              v-if="claim.isManual"
              ref="fileUpDrop"
              id="fileUploadDrop"
              v-on:vdropzone-success="successFileUpload"
              v-on:vdropzone-file-added="addFileUpload"
              v-on:vdropzone-complete="completeFileUpload"
              v-on:vdropzone-sending="sendFileUpload"
              class="dropify-wrapper dropzoneContainer"
              :options="fileUploadDropzoneOptions"
              :useCustomSlot="true">
            <div class="dropify-message" style="transform: translateY(0%); min-width: 125px;">
              <div class="d-flex justify-content-center">
                <p class="dnd-title" style="margin-right: 10px; margin-bottom: 0px; margin-top: 7px;">Drag and Drop File
                  Here Or</p>
                <button id="clickBrowseFileBtn" style="display: inline-block" type="button"
                        class="btn btn-primary waves-effect waves-light browse-btn browse-btn-files">Browse Files
                </button>
              </div>
            </div>
          </vue-dropzone>


          <div class="w-100 d-flex justify-content-end">
            <b-form-input
                placeholder="Search"
                debounce="500"
                v-model="filterFiles"
                style="width: 250px; margin-bottom: 15px"
            ></b-form-input>
          </div>

          <b-table
              :fields="filesFields"
              :items="claim.files"
              :filter="filterFiles"
              responsive
              hover
              @row-clicked="openPdf"
          >
            <template v-slot:cell(uploadDate)="row">
              <span>{{ row.item.uploadDate | formatDate }}</span>
            </template>

            <template v-slot:cell(action)="row">
              <feather-icon
                  v-if="row.item.isCanRemove"
                  icon="Trash2Icon"
                  size="21"
                  @click="removeFile(row.item.id, 'file')"
                  style="color: red; cursor: pointer"
              />
            </template>
          </b-table>

        </b-card>
        <b-card v-show="activeTab === 'images'" title="Images">
          <vue-dropzone
              v-if="claim.isManual"
              ref="imageUpDrop"
              id="imageUploadDrop"
              v-on:vdropzone-success="successImageUpload"
              v-on:vdropzone-file-added="addFileUpload"
              v-on:vdropzone-complete="completeFileUpload"
              v-on:vdropzone-sending="sendFileUpload"
              class="dropify-wrapper dropzoneContainer"
              :options="imageUploadDropzoneOptions"
              :useCustomSlot="true">
            <div class="dropify-message" style="transform: translateY(0%); min-width: 125px;">
              <div class="d-flex justify-content-center">
                <p class="dnd-title" style="margin-right: 10px; margin-bottom: 0px; margin-top: 7px;">Drag and Drop
                  Image Here Or</p>
                <button id="clickBrowseImageBtn" style="display: inline-block" type="button"
                        class="btn btn-primary waves-effect waves-light browse-btn browse-btn-files-2">Browse Images
                </button>
              </div>
            </div>
          </vue-dropzone>

          <div class="d-flex" style="flex-wrap: wrap; gap: 10px">
            <div class="" v-for="(img, ind) in claim.images" :key="img.id" @mouseover="activeImg = img.id"
                 @mouseleave="activeImg = null">
              <img :src="getSrc(img.src)" @click="slide = ind; isOpenGallery = true"
                   style="cursor: pointer; border-radius: 3px; height: 169px; object-fit: cover;">
              <div v-if="img.isCanRemove && activeImg == img.id" class="remove-img-btn"
                   @click="removeFile(img.id, 'img')">
                <feather-icon
                    icon="Trash2Icon"
                    size="21"
                    style="color: red; cursor: pointer"
                />
              </div>
            </div>
          </div>

        </b-card>
        <b-card v-show="activeTab === 'request'" title="Parts Request">

        </b-card>
      </div>

      <div class="col-lg-3">
        <b-card>
          <b-card-text><b>Repairer Name</b></b-card-text>
          <b-card-text>{{ claim.customer.name }}</b-card-text>
          <b-card-text>Repairer ID: {{ claim.customer.customerNbr }}</b-card-text>
          <b-card-text>
            <b-avatar :text="claim.customer.leads ? claim.customer.leads : '0'" style="margin-right: 10px"
                      variant="primary"></b-avatar>
            <span class="mr-auto">Leads</span>
          </b-card-text>
          <b-card-text><b>Contact Info</b></b-card-text>
          <b-card-text>Phone: {{ claim.customer.phone }}</b-card-text>
        </b-card>

        <b-card>
          <b-card-text><b>Contact Name</b></b-card-text>
          <input
              v-if="claim.isManual"
              placeholder="Contact Name"
              class="form-control"
              :readonly="!claim.isManual"
              style="margin-bottom: 10px"
              @focus="focusedElement = 'name'"
              @blur="onBlur('name')"
              @change="autoUpdateVehicleOwner"
              v-model="claim.vehicleOwner.name"
          />
          <b-card-text v-else>{{ claim.vehicleOwner.name }}</b-card-text>
          <b-card-text><b>Contact Address</b></b-card-text>
          <input
              v-if="claim.isManual"
              placeholder="Contact Address"
              class="form-control"
              style="margin-bottom: 10px"
              :readonly="!claim.isManual"
              @change="autoUpdateVehicleOwner"
              @focus="focusedElement = 'address'"
              @blur="onBlur('address')"
              v-model="claim.vehicleOwner.address"
          />
          <b-card-text v-else> {{ claim.vehicleOwner.address }}</b-card-text>
          <b-card-text><b>Contact Details</b></b-card-text>
          <b-card-text>Email:
            <input
                v-if="claim.isManual"
                placeholder="Email"
                class="form-control"
                :readonly="!claim.isManual"
                @focus="focusedElement = 'email'"
                @blur="onBlur('email')"
                @change="autoUpdateVehicleOwner"
                v-model="claim.vehicleOwner.email"
            />
            <span v-else>{{ claim.vehicleOwner.email }}</span>
          </b-card-text>
          <b-card-text>Phone:
            <input
                v-if="claim.isManual"
                placeholder="Phone"
                @focus="focusedElement = 'phone'"
                @blur="onBlur('phone')"
                class="form-control"
                :readonly="!claim.isManual"
                @change="autoUpdateVehicleOwner"
                v-model="claim.vehicleOwner.phone"
            />
            <span v-else>{{ claim.vehicleOwner.phone }}</span>
          </b-card-text>
        </b-card>
      </div>
    </div>

    <PdfViewer
        v-if="isOpenPdf"
        :documentPath="selectedSrc"
        @closePdf="isOpenPdf = false"
        :documentHeight="documentHeight"
        :documentWidth="documentWidth"></PdfViewer>

    <b-carousel
        v-if="isOpenGallery"
        :interval="0"
        v-model="slide"
        controls
        class="rfq-carousel"
        indicators
    >
      <b-carousel-slide v-for="img in claim.images" :key="img.id" :img-src="getSrc(img.src)"></b-carousel-slide>
    </b-carousel>
  </div>
</template>

<script>
import {
  BCard,
  BCardText,
  BLink,
  BFormCheckbox,
  BFormInput,
  BRow,
  BAvatar,
  BFormTextarea,
  BTable,
  BButton,
  BFormDatepicker,
  BCarousel,
  BCarouselSlide,
  BInputGroup,
  BInputGroupAppend,

} from 'bootstrap-vue'
import PdfViewer from "@/views/PdfViewer";
import Axios from "axios";
import * as dayjs from "dayjs";
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import _ from "lodash";

export default {
  components: {
    BInputGroup,
    BInputGroupAppend,
    BCard,
    BFormDatepicker,
    BCardText,
    BLink,
    BFormCheckbox,
    BFormInput,
    BRow,
    BAvatar,
    BFormTextarea,
    PdfViewer,
    BTable,
    BButton,
    BCarousel,
    BCarouselSlide,
    vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      arrivedDateValue: '',
      pickUpDateValue: '',
      completedDateValue: '',
      startDateValue: '',
      interval: null,
      isProcessing: false,
      cancelToken: null,
      timestampDelay: 0,
      activeTab: 'notes',
      filesFields: [
        {
          label: 'File name',
          key: 'fileName',
          sortable: false,
        },
        {
          label: 'Date - Time',
          key: 'uploadDate',
          sortable: false,
        },
        {
          label: 'Size',
          key: 'size',
          sortable: false,
        },
        {
          label: 'Action',
          key: 'action',
          sortable: false,
        },
      ],
      filterFiles: '',
      fileUploadDropzoneOptions: {
        headers: {"Authorization": localStorage.getItem('token')},
        url: appConfig.baseAPIURL + `/api/v1/claim/${this.claimId}/upload`,
        method: 'post',
        maxFilesize: 50,
        params: {
          type: 'file',
        },
        thumbnailWidth: 200,
        timeout: 300000,
        clickable: '#clickBrowseFileBtn',
        addRemoveLinks: false,
        acceptedFiles: 'application/pdf, .doc, .docx',
        dictFileTooBig: "Your file has exceeded the maximum limit of 5MB per file. Please reduce the file size and upload again",
      },
      imageUploadDropzoneOptions: {
        headers: {"Authorization": localStorage.getItem('token')},
        url: appConfig.baseAPIURL + `/api/v1/claim/${this.claimId}/upload`,
        method: 'post',
        params: {
          type: 'image',
        },
        maxFilesize: 50,
        thumbnailWidth: 200,
        timeout: 300000,
        clickable: '#clickBrowseImageBtn',
        addRemoveLinks: false,
        acceptedFiles: 'image/jpeg, image/jpg, image/png',
        dictFileTooBig: "Your file has exceeded the maximum limit of 5MB per file. Please reduce the file size and upload again",
      },
      updateData: [],
      activeImg: null,
      focusedElement: '',
      originalClaim: {},
      newNote: null,
      isNoteFocused: false,
      claim: {
        isManual: false,
        isSendingToBms: false,
        isSentToBms: false,
        isCanSendToBms: false,
        isCanUpdateBms: false,
        isUpdatingBms: false,
        isUpdatedBms: false,
        notes: [],
        "id": null,
        "refNbr": null,
        "customer": {"name": null, "customerNbr": null, "id": null, "phone": null, "leads": null},
        "taxInvoice": {
          "id": null,
          "src": null,
          "name": null
        },
        "sharedActivity": [],
        "files": [],
        "images": [],
        "partsRequest": null,
        "vehicle": {
          "rego": null,
          "make": null,
          "model": null,
          "refNbr": null,
          "arriveDate": null,
          "startDate": null,
          "completeDate": null,
          "pickupDate": null,
          "accidentDesc": null,
          "notes": null
        },
        "vehicleOwner": {
          "id": null,
          "name": null,
          "phone": null,
          "email": null,
          "address": null
        },
        "lastUpdated": null
      },
      isOpenPdf: false,
      isOpenGallery: false,
      slide: 0,
      removeFileInd: -1,
      documentHeight: 0,
      documentWidth: 0,
      selectedSrc: null,
    }
  },
  mounted() {
    if (!Number(this.$route.params.id)) {
      this.claim.isManual = true
    }
    window.addEventListener('resize', this.handleResize);
    this.handleResize();

    this.$nextTick(() => {
      setTimeout(() => {
        let fileDrop = this.$refs.fileUpDrop;
        let imageDrop = this.$refs.imageUpDrop;
        let url = appConfig.baseAPIURL + `/api/v1/claim/${this.claimId}/upload`
        if (fileDrop) {
          fileDrop.options.url = url
          fileDrop.dropzone.options.url = url
          this.fileUploadDropzoneOptions.url = url
        }
        if (imageDrop) {
          imageDrop.options.url = url
          imageDrop.dropzone.options.url = url
          this.imageUploadDropzoneOptions.url = url
        }
      }, 0)
    })
  },
  computed: {
    computedClaimNotes() {
      return _.orderBy(this.claim.notes, [(n) => {
        return new Date(n.created).getTime()
      }], ['desc'])
    },
    claimId() {
      return Number(this.$route.params.id) || Number(this.claim.id) || 0
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    clearInterval(this.interval)
  },
  methods: {
    getActivityName(a) {
      let keys = Object.keys(a).sort().join(',')
      if (a.version == 1) {
        return 'Estimate Created'
      }
      if (keys == "estimatorName,eventDate,version") {
        return 'Estimator Changed'
      }
      if (keys == "detailId,eventDate,name,preserveInvoiceNumber,useTradePrice,version") {
        return 'Excess Debtor Assigned'
      }
      if (keys == "eventDate,isInsurer,isSelfAssessed,name,preserveInvoiceNumber,timeScheduleProvider,useTradePrice,version") {
        return 'Primary Deptor Assigned'
      }
      if (keys == "claimNumber,eventDate,isAuthorising,version") {
        return 'Insurer Claim Number Changed'
      }
      if (keys == "estimateNumber,eventDate,version") {
        return 'Estimate Number Set'
      }
      if (keys == "body,colour,countryOfManufacture,crashbookId,cylinders,engineCapacity,engineNumber,eventDate,featureCodes,fuelType,jobId,make,manufacturedMonth,manufacturedYear,model,odometer,odometerDistance,paintCode,registration,registrationState,series,transmission,trimCode,tyreBrand,variant,version,vin") {
        return 'Vehicle Details Changed'
      }
      if (keys == "actualArrivalNonNullable,actualEndNonNullable,actualPickupNonNullable,actualStartNonNullable,assessingProviderId,bookingIsUnconfirmed,eventDate,expectedArrival,expectedEnd,expectedPickup,expectedStart,loanCarClassification,loanCarRequested,notes,repairDaysRequired,version") {
        return 'Vehicle Booking Added'
      }
      if (keys == "estimateNumber,eventDate,excessUseTradePrice,isPrimarySelfAssessed,isRework,jobCompleted,jobId,jobNumber,jobStarted,originalJobId,primaryUseTradePrice,profileName,profileVersion,projectCode,projectId,projectName,tags,taxRegion,version") {
        return 'Job Requested'
      }
      if (keys == "eventDate,jobIssuedDate,jobNumber,version") {
        return 'Job Issued'
      }
      if (keys == "eventDate,jobIssuedDate,jobNumber,version") {
        return 'Estimate Followed Up'
      }

      return ''
    },
    saveNote() {
      if (!_.isArray(this.claim.notes)) {
        // this.$nextTick(() => {
          this.$set(this.claim, 'notes', [])
        // })
      }
      this.claim.notes.push({
        body: this.newNote,
        created: new Date()
      })
      let v = _.cloneDeep(this.newNote)
      this.newNote = null
      this.activeTab = 'notes';

      Axios.post(`/api/v1/claim/${this.claimId}`, {
        addNote: v
      }).then((r) => {
        if (r?.data?._status) {

        }
      })
    },
    onlyDateFormat(event) {
      let keyCode = (event.keyCode ? event.keyCode : event.which);
      if ((keyCode < 47 || keyCode > 57) ) {
        event.preventDefault();
      }
    },
    onBlur(field) {
      this.focusedElement = '';
      if (_.isEmpty(this.originalClaim)) {
        return
      }
      // console.log(field, this.originalClaim.vehicle.arriveDate, this.claim.vehicle.arriveDate)
      if (field == 'rego') {
        if (!_.isEqual(this.originalClaim.vehicle.rego, this.claim.vehicle.rego)) {
          this.autoUpdateVehicle()
        }
      } else if (field == 'make') {
        if (!_.isEqual(this.originalClaim.vehicle.make, this.claim.vehicle.make)) {
          this.autoUpdateVehicle()
        }
      } else if (field == 'model') {
        if (!_.isEqual(this.originalClaim.vehicle.model, this.claim.vehicle.model)) {
          this.autoUpdateVehicle()
        }
      } else if (field == 'refNbr') {
        if (!_.isEqual(this.originalClaim.vehicle.refNbr, this.claim.vehicle.refNbr)) {
          this.autoUpdateVehicle()
        }
      } else if (field == 'accidentDesc') {
        if (!_.isEqual(this.originalClaim.vehicle.accidentDesc, this.claim.vehicle.accidentDesc)) {
          this.autoUpdateVehicle()
        }
      } else if (field == 'name') {
        if (!_.isEqual(this.originalClaim.vehicleOwner.name, this.claim.vehicleOwner.name)) {
          this.autoUpdateVehicleOwner()
        }
      } else if (field == 'address') {
        if (!_.isEqual(this.originalClaim.vehicleOwner.address, this.claim.vehicleOwner.address)) {
          this.autoUpdateVehicleOwner()
        }
      } else if (field == 'email') {
        if (!_.isEqual(this.originalClaim.vehicleOwner.email, this.claim.vehicleOwner.email)) {
          this.autoUpdateVehicleOwner()
        }
      } else if (field == 'phone') {
        if (!_.isEqual(this.originalClaim.vehicleOwner.phone, this.claim.vehicleOwner.phone)) {
          this.autoUpdateVehicleOwner()
        }
      } else if (field == 'startDate') {
        if (!_.isEqual(this.originalClaim.vehicle.startDate, this.claim.vehicle.startDate)) {
          this.autoUpdateVehicle()
        }
      } else if (field == 'arriveDate') {
        if (!_.isEqual(this.originalClaim.vehicle.arriveDate, this.claim.vehicle.arriveDate)) {
          this.autoUpdateVehicle()
        }
      } else if (field == 'completeDate') {
        if (!_.isEqual(this.originalClaim.vehicle.completeDate, this.claim.vehicle.completeDate)) {
          this.autoUpdateVehicle()
        }
      } else if (field == 'pickupDate') {
        if (!_.isEqual(this.originalClaim.vehicle.pickupDate, this.claim.vehicle.pickupDate)) {
          this.autoUpdateVehicle()
        }
      }
    },
    autoUpdateVehicle() {
      this.setUpdateData('vehicle')
    },
    autoUpdateVehicleOwner() {
      this.setUpdateData('vehicleOwner')
    },
    autoSave() {
      let updateDataCopy = _.cloneDeep(this.updateData)
      this.updateData.splice(0)
      let data = {}
      _.forEach(updateDataCopy, (field) => {
        data[field] = this.claim[field]
      })
      if (!this.claimId) {
        Axios.post(`/api/v1/claim/${this.claimId}`, data).then((r) => {
          if (r?.data?._status && r?.data?.claimId) {
            this.claim.id = r.data.claimId

            this.$nextTick(() => {
              setTimeout(() => {
                let fileDrop = this.$refs.fileUpDrop;
                let imageDrop = this.$refs.imageUpDrop;
                let url = appConfig.baseAPIURL + `/api/v1/claim/${this.claimId}/upload`
                if (fileDrop) {
                  fileDrop.options.url = url
                  fileDrop.dropzone.options.url = url
                  this.fileUploadDropzoneOptions.url = url
                }
                if (imageDrop) {
                  imageDrop.options.url = url
                  imageDrop.dropzone.options.url = url
                  this.imageUploadDropzoneOptions.url = url
                }
              }, 0)
            })

            this.$router.push({name: 'claimView', params: {id: r.data.claimId}})
          }
        })
      } else {
        if (this.cancelToken) {
          this.cancelToken.cancel()
        }
        this.cancelToken = null

        Axios.put(`/api/v1/claim/${this.claimId}`, data).then((r) => {
          if (r?.data?._status && r?.data?.claim) {
            this.claim = _.cloneDeep(r.data.claim)
          }
        }).finally(() => {
          this.isProcessing = false
        })
      }
    },
    setUpdateData: function (field) {
      this.isProcessing = true
      if (!_.includes(this.updateData, field)) {
        this.updateData.push(field)
      }
      this.debouncedAutoSave()
    },
    successImageUpload(file, response) {
      if (response._status && response.file) {
        this.claim.images.push(response.file);

        const vm = this;
        setTimeout(function () {
          vm.$refs.imageUpDrop.removeFile(file);
        }, 1000)
      }
    },
    successFileUpload(file, response) {
      if (response._status && response.file) {
        this.claim.files.push(response.file);

        const vm = this;
        setTimeout(function () {
          vm.$refs.fileUpDrop.removeFile(file);
        }, 1000)
      }
    },
    sendFileUpload($event) {
      $event.previewElement.children[($event.previewElement.children.length - 1)].style.display = "none";
    },
    completeFileUpload($event) {
      $event.previewElement.children[($event.previewElement.children.length - 1)].removeAttribute("style");
    },
    addFileUpload($event) {
      $event.previewElement.children[($event.previewElement.children.length - 1)].style.display = "none";
    },
    sendToBMS() {
      if (this.claim.isSendingToBms || this.claim.isSentToBms) {
        return
      }
      this.$set(this.claim, 'isSendingToBms', true)
      // this.claim.isSendingToBms = true
      Axios.post(`/api/v1/claim/${this.claimId}/send-to-bms`, this.updateData).then((r) => {
        if (r?.data?._status) {
        }
      })
    },
    onClickDownload: function () {
      let fileLink = document.createElement('a')
      let imageUrl = this.getSrc(this.claim.images[this.slide].src);
      fileLink.href = imageUrl
      fileLink.target = "_blank"
      let names = imageUrl.split('/')
      fileLink.setAttribute('download', names.length > 0 ? names[names.length - 1] : 'image.jpg')
      fileLink.click()
    },
    removeFile(id, type) {

      if (type == 'file') {
        let index = _.findIndex(this.claim.files, (f) => {
          return Number(f.id) == Number(id)
        })
        if (index !== -1) {
          this.removeFileInd = index
          this.claim.files.splice(index, 1)
        }
      } else {
        let index = _.findIndex(this.claim.images, (f) => {
          return Number(f.id) == Number(id)
        })
        if (index !== -1) {
          if (this.claim.images.length == 1) {
            this.isOpenGallery = false
          }
          if (this.isOpenGallery) {
            this.slide -= 1
          }
          this.claim.images.splice(index, 1)
        }
      }

      Axios.delete(`/api/v1/claim/${this.claimId}/file/${id}`).then((r) => {
        if (r?.data?._status) {

        }
      })
    },
    handleResize() {
      this.documentHeight = window.innerHeight - 50

      this.documentWidth = window.innerWidth - document.getElementsByClassName('main-menu')?.[0]?.clientWidth
    },
    openPdf(item, index) {
      if (this.removeFileInd == index) {
        this.removeFileInd = -1
      } else {
        this.isOpenPdf = true
        this.selectedSrc = this.getSrc(item.src);
      }
    },
    getSrc(src) {
      return appConfig.baseAPIURL + src
    },
    formatDate(v) {
      if (v) {
        if (_.includes(v, '/')) {
          return dayjs(v.split('/').reverse().join('-')).format('MMM DD YYYY')
        }
        return dayjs(v).format('MMM DD YYYY')
      }
      return ''
    },
    formatDate2(v) {
      if (v) {
        return dayjs(v).format('DD/MM/YYYY')
      }
      return ''
    },
    formatDate3(v) {
      if (v) {
        return dayjs(v).format('dddd DD MMM YYYY')
      }
      return ''
    },
    formatDate4(v) {
      if (v) {
        return dayjs(v).format('DD/MM/YYYY hh:mm A')
      }
      return ''
    },
    loadClaim(isCheckForFocus = false) {
      if (!this.claimId) {
        return
      }
      Axios.get(`/api/v1/claim/${this.claimId}`).then((r) => {
        if (r?.data?._status && r?.data?.claim) {

          if (this.isProcessing) {
            let data = _.cloneDeep(r.data.claim)
            data.vehicle = this.claim.vehicle;
            data.vehicleOwner = this.claim.vehicleOwner;
            this.claim = data;
          } else {
            if (isCheckForFocus && this.focusedElement) {
              this.originalClaim = _.cloneDeep(r.data.claim)
              let data = _.cloneDeep(r.data.claim)
              if (this.focusedElement == 'rego') {
                data.vehicle.rego = this.claim.vehicle.rego
              } else if (this.focusedElement == 'make') {
                data.vehicle.make = this.claim.vehicle.make
              } else if (this.focusedElement == 'model') {
                data.vehicle.model = this.claim.vehicle.model
              } else if (this.focusedElement == 'refNbr') {
                data.vehicle.refNbr = this.claim.vehicle.refNbr
              } else if (this.focusedElement == 'accidentDesc') {
                data.vehicle.accidentDesc = this.claim.vehicle.accidentDesc
              } else if (this.focusedElement == 'name') {
                data.vehicleOwner.name = this.claim.vehicleOwner.name
              } else if (this.focusedElement == 'address') {
                data.vehicleOwner.address = this.claim.vehicleOwner.address
              } else if (this.focusedElement == 'email') {
                data.vehicleOwner.email = this.claim.vehicleOwner.email
              } else if (this.focusedElement == 'phone') {
                data.vehicleOwner.phone = this.claim.vehicleOwner.phone
              } else if (this.focusedElement == 'startDate') {
                data.vehicle.startDate = this.claim.vehicle.startDate
              } else if (this.focusedElement == 'arriveDate') {
                data.vehicle.arriveDate = this.claim.vehicle.arriveDate
              } else if (this.focusedElement == 'completeDate') {
                data.vehicle.completeDate = this.claim.vehicle.completeDate
              } else if (this.focusedElement == 'pickupDate') {
                data.vehicle.pickupDate = this.claim.vehicle.pickupDate
              }
              this.claim = data;
            } else {
              this.claim = _.cloneDeep(r.data.claim)
            }
          }

          this.$nextTick(() => {
            setTimeout(() => {
              let fileDrop = this.$refs.fileUpDrop;
              let imageDrop = this.$refs.imageUpDrop;
              let url = appConfig.baseAPIURL + `/api/v1/claim/${this.claimId}/upload`
              if (fileDrop) {
                fileDrop.options.url = url
                fileDrop.dropzone.options.url = url
                this.fileUploadDropzoneOptions.url = url
              }
              if (imageDrop) {
                imageDrop.options.url = url
                imageDrop.dropzone.options.url = url
                this.imageUploadDropzoneOptions.url = url
              }
            }, 0)
          })

          // if (!isCheckForFocus) {
          //   let activity = this.claim.sharedActivity;
          //   let r = {}
          //   _.forEach(activity, (a) => {
          //     let keys = Object.keys(a).sort().join(',')
          //     if (r[keys]) {
          //       r[keys].push(a.version)
          //     } else {
          //       r[keys] = []
          //       r[keys].push(a.version)
          //     }
          //   })
          //   console.log('result', r)
          //
          //   let r2 = {}
          //   _.forIn(r, (value, key) => {
          //     if (value.length == 1) {
          //       r2[key] = value
          //     }
          //   })
          //   console.log('result2', r2)
          // }
        }
      })
    },
    checkUpdate() {
      if (!this.claimId) {
        return
      }
      let timestamp = this.$store.getters['lastTimestamp'] ? this.$store.getters['lastTimestamp'] - 5 - this.timestampDelay : 0
      if (this.cancelToken) {
        this.cancelToken.cancel()
      }
      this.cancelToken = Axios.CancelToken.source()
      Axios.get(`/api/v1/update/claim/${this.claimId}/${timestamp}`, {
        cancelToken: this.cancelToken.token
      }).then((r) => {
        if (r?.data?._status && r?.data?.update?.isNeedUpdate) {
          this.loadClaim(true)
        }
      }).catch((e) => {
        if (Axios.isCancel(e)) {
          this.timestampDelay += 5
        }
      })
    }
  },
  created() {
    this.debouncedAutoSave = _.debounce(this.autoSave, 1000)

    this.loadClaim(false);

    this.interval = setInterval(() => {
      this.checkUpdate();
    }, 5000)
  }
}
</script>

<style>
.rfq-view-page .rfq-carousel img {
  max-height: 90vh;
  object-fit: scale-down;
}
.rfq-view-page .save-note-btn {
  position: absolute;
  right: 17px;
  bottom: 13px;
}
.rfq-view-page .active-note {
  border-color: #7367f0 !important;
}
.rfq-view-page .save-note-btn:disabled {
  opacity: 1;
  background-color: #a49cf5 !important;
  border-color: #a49cf5 !important;
}
.rfq-view-page .bms-btn:disabled {
  opacity: 1;
  cursor: not-allowed;
  background-color: #7367f0 !important;
}
.rfq-view-page .bms-btn:disabled:active {
  opacity: 1;
  cursor: not-allowed;
  background-color: #7367f0 !important;
}
.rfq-view-page .close-btn {
  /*transform: translate(0px, -20px);*/
  font-size: 40px;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.54);
  line-height: 10px;
  /*position: absolute;*/
  /*right: 30px;*/
}

.rfq-view-page .b-form-datepicker .btn svg {
  transform: translateY(-2px);
}

.rfq-view-page .carousel-control-prev,
.rfq-view-page .carousel-control-prev-icon,
.rfq-view-page .carousel-control-next,
.rfq-view-page .carousel-control-next-icon {
  opacity: 1 !important;
}

.rfq-view-page .carousel-control-prev-icon,
.rfq-view-page .carousel-control-next-icon {
  height: 50px;
  width: 50px;
  background-color: lightgray;
  border-radius: 5px;
}

.rfq-view-page .remove-img-btn {
  cursor: pointer;
  border-radius: 4px;
  width: 33px;
  height: 33px;
  background-color: white;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  position: relative;
  float: right;
  margin: -17px;
  transform: translate(-26px, 27px);
}

.rfq-view-page .remove-img-btn-2 {
  cursor: pointer;
  border-radius: 4px;
  width: 33px;
  height: 33px;
  /*background-color: white;*/
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin: 0px 10px;
  /*position: relative;*/
  /*float: right;*/
  /*margin: -17px;*/
  /*transform: translate(-26px, 27px);*/
}

.rfq-view-page #fileUploadDrop,
.rfq-view-page #imageUploadDrop {
  padding: 0px 20px !important;
  min-height: 60px;
  margin-bottom: 15px;
}

.rfq-view-page #fileUploadDrop .dz-preview,
.rfq-view-page #imageUploadDrop .dz-preview {
  height: 180px;
}

.rfq-view-page #fileUploadDrop .dz-message,
.rfq-view-page #imageUploadDrop .dz-message {
  margin: 10px 0px;
}

.rfq-view-page .page-breadcrumbs-manual {
  margin-left: 22px;
}

.rfq-view-page .form-control:read-only {
  background-color: white !important;
}

.rfq-view-page .custom-control-input[disabled] ~ .custom-control-label, .custom-control-input:disabled ~ .custom-control-label {
  color: black !important;
}


.rfq-view-page .custom-control-input[disabled] ~ .custom-control-label::before, [dir] .custom-control-input:disabled ~ .custom-control-label::before {
  background-color: #fff !important;
  border: #d8d6de solid 1px !important;
}

.rfq-view-page .custom-control-input:checked[disabled] ~ .custom-control-label::before, [dir] .custom-control-input:checked:disabled ~ .custom-control-label::before {
  border-color: #7367f0 !important;
  background-color: #7367f0 !important;
}

.dashboard-tab-line {
  height: 5px;
  background-color: #7367f0;
  border-radius: 5px 5px 0px 0px;
}

.dashboard-tab-title .dashboard-tab-text.active {
  color: #7367f0;
}

.dashboard-tab-title .dashboard-tab-text {
  height: 40px;
  padding: 5px 15px;
  align-items: start;
  display: flex;
}

.main-tab-line {
  height: 7px;
  width: 100%;
  background-color: #e3e4e7;
}

.dashboard-tab-title {
  flex-direction: column;
  cursor: pointer;
}
</style>
<style scoped>
.icon-calendar-form-datepicker{
  border: 1px solid #d8d6de;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}
.icon-calendar-form-datepicker >>> button{
  background-color: white !important;
  box-shadow: none !important;
  border: 0 !important;
}
.icon-calendar-form-datepicker >>> button svg{
  color: rgba(94, 88, 115, 0.75);
}
.icon-calendar-form-datepicker[class$="show"]{
  border-color: #7266ee !important;
}
</style>
